import { addStyles } from 'ethcss'
import { IStyles } from 'theme'
import { colors, indents, textSizes } from 'theme'
import grid from 'blocks.simple/grid/grid.jcss'

export const secondFactorLoginStepStyles: IStyles = {
    methods: {
        ...grid.row,
        ...grid.center,
        flexWrap: 'wrap',
        gap: indents.mini,
        marginBottom: indents.md,
    },
    methodBtn: {
        cursor: 'pointer',
        padding: `${indents.mini}px ${indents.md}px`,
        borderRadius: 4,
        fontSize: textSizes.normal,
        color: colors.grey,
        border: `1px solid ${colors.cloud}`,
        background: 'transparent',
    },
    methodBtnActive: {
        color: colors.blackLight,
        borderColor: colors.blackLight,
        fontWeight: 'bold',
    },
    hint: {
        ...grid.mt_mini,
        fontSize: textSizes.normal,
        color: colors.grey,
        textAlign: 'center',
    },
    link: {
        ...grid.mt_mini,
        fontSize: textSizes.normal,
        color: colors.blackLight,
        textAlign: 'center',
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    email: {
        textAlign: 'center',
        marginBottom: indents.md,
        fontWeight: 'bold',
    },
}

addStyles(secondFactorLoginStepStyles)
